// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"160ecc94","513":"268ba785"}[chunkId] + ".chunk.js";
};